import Vue from './main.js'
import { router } from './main.js'

export default {
    permissions: {
        IS_ADMIN: 'is_admin'
        //IS_USER: 'is_user'//every logged in user is_user, so this is obsolete
    },

    user: {
        authenticated: false,
        profile: {
            permissions: null,
            username: null,
            firstName: null,
            lastName: null,
            id: null
        }
    },

    tokenRefreshTimeout: null,
    useRefreshTimeout: false, //do not use refresh timeout

    verifyToken(onSuccess) {
        let token = localStorage.getItem('id_token')
        if (token !== null) {
            Vue.http.get('api/v1/auth/check').then(
                (response) => {
                    this.storeUserData(response)
                    onSuccess()
                },
                (response) => {
                    //if there is an error -> signout
                    this.signout(this)
                }
            )
        }
    },

    refresh() {
        Vue.http.post('api/v1/auth/refresh').then(
            (response) => {
                this.setToken(response)
                this.storeUserData(response)
            },
            (response) => {
                this.signout()
            }
        )
    },

    signin(context, username, password) {
        Vue.http
            .post('api/v1/admin-login', {
                username: username,
                password: password
            })
            .then(
                (response) => {
                    context.error = false
                    context.isLoading = false

                    this.setToken(response)
                    this.storeUserData(response)

                    router.push({
                        name: 'users'
                    })
                },
                (response) => {
                    context.error = true
                    context.isLoading = false
                }
            )
    },

    signout() {
        Vue.http.post('api/v1/auth/logout').then(
            (response) => {
                this.clearToken()
            },
            (error) => {
                this.clearToken()
            }
        )
    },

    clearToken() {
        localStorage.removeItem('id_token')
        Vue.http.headers.common['Authorization'] = 'Bearer null' //set auth header explicitly to Bearer with empty/null token

        this.user.authenticated = false
        this.user.profile.permissions = null
        this.user.profile.username = null
        this.user.profile.firstName = null
        this.user.profile.lastName = null
        this.user.profile.id = null

        //only push to signin if we are not already there (because vue does not like it)
        if (router.currentRoute.name !== 'signin') {
            router.push({
                name: 'signin'
            })
        }
    },

    storeUserData(response) {
        this.user.profile.permissions = response.body.user_data.permissions
        this.user.profile.username = response.body.user_data.username
        this.user.profile.firstName = response.body.user_data.first_name
        this.user.profile.lastName = response.body.user_data.last_name
        this.user.profile.id = response.body.user_data.id
        this.user.authenticated = true
    },

    setToken(response) {
        localStorage.setItem('id_token', response.body.access_token)
        Vue.http.headers.common['Authorization'] = 'Bearer ' + response.body.access_token

        if (this.useRefreshTimeout) {
            this.setTokenRefreshTimeout(response.body.ttl * 1000) //ttl*1000=milliseconds
        }
    },

    setTokenRefreshTimeout(milliseconds) {
        if (this.tokenRefreshTimeout !== null) {
            clearTimeout(this.tokenRefreshTimeout)
        }
        this.tokenRefreshTimeout = setTimeout(() => {
            //if timer still existent: refresh!
            this.refresh()
        }, milliseconds - 5 * 60 * 1000) //timer expires in ttl minus 5 minutes, so early enough to still be valid
    },

    isUserAuthenticated() {
        return this.user.authenticated
    }
}
